<template lang="pug">
  #GroupPushIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 本月壽星
    .container-width(
      style="padding-bottom: 135px;"
    )
      .p-3
        b-card.mb-2.customerCard.overflow-hidden.position-relative(
          bg-variant="white",
          v-for="(user,index) in memberList",
          :key="user.member_id",
          v-if="memberList"
        )
          .row.align-items-center.no-gutters
            input.custom_checker(
              type="checkbox",
              :id="`checkbox-group-${index}`",
              name="selectTemps",
              :checked="isChecked(index)"
              :class="{ 'hidden-check': isChecked(index) }"
            )
            .input_wrap.ml-3(@click.stop.prevent="selectMemberHandler(user.member_id)")
              .custom-check-icon.border-black.mr-2
            .ml-3.pr-1(
              @click.stop.prevent="showUserInfoHandler(user.member_id)"
            )
              ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="user.picture_url",
                :style="{ 'width': '60px', 'height': '60px' }",
              )
            .pl-1
              p.mb-0.font-weight-bold {{ user.line_display_name }}
              p.mb-0.font-weight-bold.text-gray {{ user.note_name ? user.note_name : '-' }}
              p.mb-0.font-weight-bold.text-gray {{ user.card_type ? user.card_type : '-' }}

        p.mb-0.text-center(
          v-if="!memberList || memberList.length === 0"
        ) 無選擇推播目標
      .d-flex.w-100.bg-black.position-fixed.align-items-center.justify-content-center(
        style="bottom: 9rem;left: 0;height: 60px;z-index: 3;",
        v-if="memberList && memberList.length !== 0",
      )
        b-button.font-weight-bold.mx-3.btn-custom(
          variant="primary",
          block,
          @click="changeUserhHandler(true)",
          style="height: 60%;border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
        ) 全部選取
        b-button.font-weight-bold.mt-0.mx-3.btn-custom(
          variant="primary",
          block,
          @click="changeUserhHandler(false)",
          style="height: 60%;border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
        ) 取消選取

    ChatGroupPushFooter.outline-none(
      v-if="memberList && memberList.length !== 0",
      @sendHandler="sendHandler"
    )

    SitckerModel(
      title="貼圖",
      @postSendApiHandler="postSendApiHandler"
    )

    TempModel(
      title="訊息模板",
      :multicastPush="true",
      :users="selectUsers"
    )

    TextPushModel(
      title="群發訊息",
      @sendHandler="sendHandler"
    )

    InvitationModel(
      title="邀請函",
      :multicastPush="true",
      :users="selectUsers"
    )

    ProductFitModel(
      title="線上導購",
      :multicastPush="true",
      :users="selectUsers"
    )

</template>

<script>
  import { mapState } from 'vuex';
  import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
  import ChatGroupPushFooter from '@/components/chat/ChatGroupPushFooter.vue';
  import SitckerModel from '@/components/customerModel/stickerModel.vue';
  import TextPushModel from '@/components/customerModel/textPushModel.vue';
  import TempModel from '@/components/customerModel/tempModel.vue';
  import InvitationModel from '@/components/customerModel/invitationModel.vue';
  import ProductFitModel from '@/components/customerModel/productFitModel.vue';
  import JQuery from 'jquery';
  import { SA_MY_CUSTOMER_INDEX } from '@/router/sa/my-customer';

  const _ = require('lodash');

  const $ = JQuery;

  export default {
    name: 'BirthdayPushIndex',
    components: {
      ProfilePhotoSticker,
      ChatGroupPushFooter,
      SitckerModel,
      TempModel,
      TextPushModel,
      InvitationModel,
      ProductFitModel
    },
    data() {
      return {
        selectUsers: [],
        demoUsers: [{
          birthday: '1993-09-05',
          card_type: '集愛會員',
          chinese_last_name: 'test',
          latest_reservation_start_at: null,
          line_display_name: 'demo',
          mars_id: '45Z20005005',
          member_id: 5,
          member_line_uuid: 'Ueb9099f62f93aaebcc7783fbd78e8cc7',
          note_name: 'demo',
        }]
      };
    },
    created() {
      const vm = this;
      $('#home').animate({
        scrollTop: 0
      }, 10);
      const input = {
        per_page: 999999
      };
      vm.$store.dispatch('sa_inform_list/getBirthMemberListHandler', input).then(() => {
        vm.selectUsers = _.cloneDeep(vm.memberSelectedList);
      });

      vm.$store.commit('toggleLoading', false);
    },
    methods: {
      sendHandler(data) {
        const vm = this;
        if (!data || !data.type) return;

        switch (data.type) {
          case 'text':
            vm.postSendApiHandler(data);
            break;
          case 'image':
            vm.$swal.fire({
              title: '圖片上傳中，請稍候',
              allowOutsideClick: false,
              heightAuto: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });

            // 先上傳圖片, 之後再打 Post Chat Api
            // 圖片開放可上傳複數
            vm.$store.dispatch("sa_chat/saveImgHandler", data.formData).then((res) => {
              if (res.length > 0) {
                const images = res.map((item) => ({
                  type: "image",
                  file_id: item.data.file_id,
                  image: item.data.url,
                }));
                vm.postSendApiHandler(images);
              } else {
                vm.$swal.close();
              }
            });
            break;
          case 'video':
            vm.$swal.fire({
              title: '影片上傳中，請稍候',
              allowOutsideClick: false,
              heightAuto: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });
            // 先上傳影片, 之後再打 Post Chat Api
            vm.$store.dispatch('sa_chat/saveVideoHandler', data.file.file)
              .then((res) => {
                vm.$swal.close();
                if (res.length === 1) {
                  vm.postSendApiHandler({
                    type: 'video',
                    video: res[0].data.url,
                    previewImage: res[0].data.previewImage
                  });
                } else {
                  vm.$swal.close();
                  console.log('TODO: 群發！');
                }
              });
            break;
          default:
            break;
        }
      },
      // 送出訊息
      postSendApiHandler(data) {
        const vm = this;
        // Loding
        vm.$swal.fire({
          title: '訊息送出中，請稍候',
          allowOutsideClick: false,
          heightAuto: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const members_uuid = _.map(vm.selectUsers, (val) => val.member_line_uuid || val.line_uuid);

        vm.$store.dispatch('sa_group_push/multicastSendHandler', {
          to: members_uuid,
          messages: Array.isArray(data) ? data : [data],
        })
          .then(() => {
            vm.$swal.close();
          });
      },
      // 選擇發送對象
      selectMemberHandler(id ) {
        const vm = this;
        const selectMembers_key = _.findKey(vm.selectUsers, (val) => val.member_id === id);
        if (selectMembers_key) {
          vm.selectUsers.splice(selectMembers_key, 1);
        } else {
          const members_key = _.findKey(vm.memberList, (val) => val.member_id === id);
          if (members_key) {
            vm.selectUsers.push(vm.memberList[members_key]);
          }
        }
      },
      isChecked(index) {
        const vm = this;
        const key = _.findKey(vm.selectUsers, (val) => val.member_id === vm.memberList[index].member_id);

        if (key) {
          return true;
        }
        return false;
      },
      showUserInfoHandler(userId) {
        const vm = this;
        if (vm.selectMode) return;
        vm.$router.push({
          name: SA_MY_CUSTOMER_INDEX,
          params: {
            userId
          }
        }).catch(() => {});
      },
      changeUserhHandler(bool) {
        const vm = this;
        if (bool) {
          vm.selectUsers = [];
          vm.selectUsers = vm.memberList;
        } else {
          vm.selectUsers = [];
        }
      }
    },
    computed: {
      ...mapState({
        memberList: (state) => state.sa_inform_list.birthdayList,
        memberSelectedList: (state) => state.sa_inform_list.birthdaySelectedList
      })
    },
    beforeRouteLeave(to, from, next) {
      const vm = this;
      if (to.name === 'sa-my-customer-index') {
        vm.$store.commit('sa_inform_list/setBirthMemberSelectedList', vm.selectUsers);
      } else {
        vm.$store.commit('sa_inform_list/setBirthMemberSelectedList', []);
      }
      next();
    }
  };
</script>

<style lang="scss" scoped>
  .searchArea {
    &__iconArrow {
      position: absolute;
      right: 10px;
      top: 5px;
      outline: none;
      transform: rotate(0deg);
      transition: all .3s;
    }
    &__iconArrow.collapsed {
      transform: rotate(180deg);
    }
  }

  .card {
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #d0cdcd;
    &-hasNews {
      &::after {
        content: "";
        position: absolute;
        right: 0.4rem;
        top: 0.4rem;
        background-color: #ef4852;
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 50%;
      }
    }
  }

  .card-body {
    padding: 1rem 0;
  }

  .ProfilePhotoSticker {
    border: 0.2rem solid #000!important;
  }

  .custom-check-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    margin-right: 1.2rem;
    position: relative;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon {
    background-color: #ef4852;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon::after {
    display: block;
  }

  .custom-check-icon::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1rem;
    background-image: url(../../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  .border-black{
    border: 0.2rem solid #000;
  }

  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .invitation-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    margin-right: 1.2rem;
    position: relative;
  }

  .invitation_checker:checked ~ .input_wrap .invitation-icon {
    background-color: #ef4852;
  }

  .invitation_checker:checked ~ .input_wrap .invitation-icon::after {
    display: block;
  }

  .invitation-icon::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1rem;
    background-image: url(../../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
</style>
